import React, { memo, forwardRef, useCallback, useMemo, useRef } from 'react';
import classnames from 'classnames';
import { createUseStyles, Select } from '@Sage/hoi-poi-ui';
import { useWeb5Context } from 'lib/Web5Context';

import styles from './styles';
const useStyles = createUseStyles(styles, 'FieldFormatter');

const FieldFormatter = (
    {
        data,
        syncNames,
        className,
        getMatchOptions,
        rowIndex,
        onChange,
        loadOptions,
        node,
        api,
        openCreateFieldModal,
    },
    ref,
) => {
    const classes = useStyles();
    const fieldClassName = classnames(className, classes.field);
    const { t } = useWeb5Context();
    const selectRef = useRef();

    const value = useMemo(() => {
        if (!data.nameField) return null;
        let newValue;
        const matchOptions = getMatchOptions();

        matchOptions[0].options
            ? matchOptions.forEach((option) => {
                  let innerOption = option?.options?.find(
                      (option) => option.value === data.nameField,
                  );
                  if (innerOption) newValue = innerOption;
              })
            : (newValue = matchOptions.find((option) => option.value === data.nameField) || null);

        return newValue;
    }, [data.nameField, getMatchOptions]);

    const onChangeSelect = useCallback(
        (option) => {
            onChange(rowIndex, option ? option.value : '', node, api);
        },
        [node, onChange, rowIndex, api],
    );

    const overrides = useMemo(() => {
        return {
            control: { style: { background: 'none', border: 'none' } },
            controlFocused: { style: { background: 'none', border: 'none' } },
        };
    }, []);

    const isReadOnly = useMemo(
        () => syncNames?.includes(data.nameField) || false,
        [data.nameField, syncNames],
    );

    const action = useMemo(
        () => [
            {
                label: t('cfm_label_create_as_new_one'),
                onClick: () => {
                    openCreateFieldModal({ rowIndex });
                    selectRef.current.blur();
                },
                iconType: 'plus',
            },
        ],
        [t, openCreateFieldModal, rowIndex],
    );

    return (
        <div ref={ref} className={fieldClassName}>
            <Select
                getRef={(ref) => {
                    selectRef.current = ref;
                }}
                placeholder={t('cfm_placeholder_select_one_match')}
                options={[...loadOptions()]}
                onChange={onChangeSelect}
                value={value}
                isFullWidth
                isReadOnly={isReadOnly}
                overrides={overrides}
                cacheOptions={false}
                actions={action}
            />
        </div>
    );
};

export default memo(forwardRef(FieldFormatter));
